<template>
  <div v-loading="loading" class="alarmClass">
    <div :style="contentStyle">
      <avue-crud
        :option="option"
        :data="data"
        :page.sync="page"
        ref="crud"
        @size-change="sizeChange"
        @selection-change="selectionChange"
      @refresh-change="onLoad"
      >
        <template slot="menuLeft">
          <el-button type="primary" size="small" v-if="model!=='view'" @click="addFamilyForm"> 新 增</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text" size="small" v-if="model!=='view'" @click="editRecord(scope.row)">编辑 </el-button>

          <el-button type="text" size="small" v-if="model!=='view'" @click="deleteFun(scope.row.id)">删除 </el-button>
        </template>
      </avue-crud>

      <hr-dialog
      :title="formModel==='add'?'新增':'编辑'"
      :allowFull="false"
      width="60%"
      :visible.sync="familyFormVisible"
    >
      <template slot="body">
        <FamilyForm
        :model="formModel"
        :row="formRow"
          @cancle="recordCancle"
          v-if="familyFormVisible"

          @success="recordSuccess"

        ></FamilyForm>
      </template>
    </hr-dialog>
    </div>
  </div>
</template>
<script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import FamilyForm from './familyForm.vue';
import { getStore } from '@/util/store';
import {
  getMatetial,
  getTotalWarehouseWarnSetting,
  stockWarnSave,
  getWarehouseWarnSetting,
  getFamilyMemberPage,
  familyMemberRemove
} from '../api/serveItemManage';
export default {
  components: {FamilyForm},
  model: {
    prop: 'form',
    event: 'change',
  },
  props: {
    form: {},
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      contentStyle:"",
      familyFormVisible:false,
      projectList: [],
      data:[],
      formRules: {
        name: [{ required: true, message: '物料名称不能为空', trigger: 'blur' }],
        nursinghomeId: [{ required: false, message: '项目名称不能为空', trigger: 'change' }],
      },
      matetialList: [],

      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
          selection: false,
          select: true,
          index: true,
          indexLabel: '#',
          page: true,
          height: 'auto',
          calcHeight: 'auto',
          align: 'left',
          menu: this.model != 'view',
          addBtn: false,
          editBtn: false,
          delBtn: false,
          border: true,
          column: [
            {
              label: '姓名',
              prop: 'name',

            },
            {
              label: '性别',
              prop: 'sex',
            dicUrl: '/api/blade-system/dict/dictionary?code=sex',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            },
            {
              label: '电话',
              prop: 'tel',
            },
            {
              label: '与老人关系',
              prop: 'relationship',
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_relationship_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            },
            {
              label: '是否为监护人',
              prop: 'isGuardian',
            dicUrl: '/api/blade-system/dict/dictionary?code=yes_no',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            },
            {
              label: '是否紧急联系人',
              prop: 'isEmergencyContact',
            dicUrl: '/api/blade-system/dict/dictionary?code=yes_no',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            },
            {
              label: '联系地址',
              prop: 'address',
            },
            {
              label: '身份证号',
              prop: 'idNumber',
            },


          ],
        },

        // sexList:[],

    };
  },
  created() {
    this.initData();
  },
  mounted() {
    this.calcHeight();
  },
  activated(){
    this.$refs.crud.doLayout();
  },
  watch: {},
  methods: {
    calcHeight(){
        let bodyHight = document.body.clientHeight;
        let contentHeight = bodyHight - 340;
        this.contentStyle = 'max-height:' + contentHeight + 'px; overflow-y: scroll;overflow-x: hidden;';
      },
    recordSuccess(val){
      this.familyFormVisible = false;
      this.data.push(val)
      this.initData();
    },
    recordCancle(){
      this.familyFormVisible = false;
    },
    getGenderByIdNumber(idNumber) {
      if (idNumber) {
        let genderCode; // 性别代码
        if (idNumber.length == 18) {
          // 二代身份证号码长度为18位（第17位为性别代码）
          genderCode = idNumber.charAt(16);
        } else if (idNumber.length == 15) {
          // 一代身份证号码长度为15位（第15位为性别代码）
          genderCode = idNumber.charAt(14);
        }
        if (genderCode && !isNaN(genderCode)) {
          // 两代身份证号码的性别代码都为男奇女偶
          if (parseInt(genderCode) % 2 == 0) {
            return 'female';
          }
          return 'male';
        }
      }
    },

    deleteFun(id) {
      this.$confirm(' 是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          familyMemberRemove(id).then((re) => {
            this.$message.success('删除成功');
            this.initData();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    editRecord(row) {
      this.formModel = 'edit';
      this.formRow = row;
      this.familyFormVisible = true;
    },
    addFamilyForm(){
      this.formModel = 'add';
        this.familyFormVisible = true
    },
    onLoad(){

      if(getStore({
          name:'elderId'
        })){
        getFamilyMemberPage({nursinghomeId:this.nursinghomeId,elderlyId:getStore({
          name:'elderId'
        })}).then((res)=>{
          this.data = res.data.records;
        })
      }
    },
    async initData() {
      if(getStore({
          name:'elderId'
        })){
        getFamilyMemberPage({nursinghomeId:this.nursinghomeId,elderlyId:getStore({
          name:'elderId'
        })}).then((res)=>{
          this.data = res.data.records;
        })
      }

      // getDictionary('sex').then((res) => {
      //   this.sexList = res.data;
      // });
      // getDictionary('yes_no').then((res) => {
      //   this.yesNoList = res.data;
      // })
      if (this.model == 'add') {

      } else {
      }
    },
    saveRecord() {
      let result = false;
      this.$refs['formRef'].validate((valid) => {
        console.log('子', valid);
        result = valid;
      });
      return result;
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
